import { FC } from "react";
import { Helmet } from "react-helmet";
import CommonLayout from "containers/Client/AccountPage/CommonLayout";
import SectionGridFilterCardOwnerPending from "containers/ListingLocationsDashboardPage/SectionGridFilterCardOwnerPending";

export interface OwnerLocationsPageProps {
  className?: string;
}

const OwnerLocationsPage: FC<OwnerLocationsPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <div
        className={`nc-ListingFlightsPage relative overflow-hidden ${className}`}
        data-nc-id="ListingFlightsPage"
      >
        <Helmet>
          <title>
            EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France
          </title>
        </Helmet>

        <div className="">
          <SectionGridFilterCardOwnerPending className="pb-24 lg:pb-28" />
        </div>
      </div>
    </CommonLayout>
  );
};

export default OwnerLocationsPage;
